import { defineComponent as _defineComponent } from 'vue'
import { ButtonBoxLaunch, Heading } from '@warrenbrasil/nebraska-web';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { getTradeButtons, TradeButton } from '@/modules/trade/services/buttons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  setup(__props) {

const router = useRouter();
const services = ref<TradeButton[]>();

onMounted(async () => {
  services.value = await getTradeButtons();
});

const isButtonVisible = (button: TradeButton) => {
  if (button.name === 'marginAllocation') {
    return true;
  }
  return button.enabled;
};

const hasSomeButtonToShow = computed(() =>
  services.value?.some((button: TradeButton) => button.enabled)
);

function getChipCustomStyle(chipStyle: string | undefined) {
  if (!chipStyle) return;
  return `services-section__chip--${chipStyle}`;
}
function pushRoute(route: string) {
  router.push({ name: route });
}

return { __sfc: true,router, services, isButtonVisible, hasSomeButtonToShow, getChipCustomStyle, pushRoute, ButtonBoxLaunch, Heading }
}

})